import {
  AdminUserResult,
  AdminUsersResult
} from "@futuri/cloudsso-client/src/client/types/admin";
import { Module } from "vuex";
import {
  setSelectedStation,
  setSelectedBinding,
  clearSelectedBinding,
  fetchInstances
} from "./actions";
import {
  SET_SELECTED_STATION,
  SET_SELECTED_BINDING,
  SET_CACHED_INSTANCES
} from "./mutations";
import { ProductInstanceResult } from "@futuri/cloudsso-client/src/client/types/productInstances";
import router from "@/core/router";
import { LoginResult } from "@futuri/cloudsso-client/src/client/types/api";
import { boundInstances } from "./getters";

export interface AdminUserPostState {
  selectedStation?: string;
  selectedBinding?: string;
  cachedInstances?: CachedInstances;
}

export interface CachedInstances {
  companyName?: string;
  instances?: ProductInstanceResult[];
}

const adminUserPostModule: Module<AdminUserPostState, any> = {
  namespaced: true,
  getters: {
    selectedStation: state => state.selectedStation,
    selectedBinding: state => state.selectedBinding,
    selectedBindingInstance: state => {
      const instances = state.cachedInstances?.instances;
      const instanceId = state.selectedBinding;

      return instanceId
        ? instances?.filter(inst => inst.instanceId === instanceId)[0]
        : undefined;
    },
    hasSelectedStation: state => !!state.selectedStation,
    hasSelectedBinding: state => !!state.selectedBinding,
    cachedInstances: state => state.cachedInstances?.instances ?? [],

    allInstances: (_, getters) => getters.cachedInstances?.instances,

    currentUser: (
      _state,
      _getters,
      _rootState,
      rootGetters
    ): AdminUserResult | undefined => {
      // const allUsers = (rootGetters['admin/allUsers'] ?? []) as AdminUserResult[]
      const users = (rootGetters.portalData as LoginResult)?.users ?? [];
      const { email } = router.currentRoute.params;

      const user = users.filter(u => u.email === email)[0];
      return user;
    },

    currentCompany: (_state, getters): string | undefined => {
      const user = getters.currentUser;
      const companyName = user?.companyName ?? user?.postDetails?.company;

      return companyName;
    },

    boundInstances
  },
  actions: {
    setSelectedStation,
    setSelectedBinding,
    clearSelectedBinding,
    fetchInstances
  },
  mutations: {
    SET_SELECTED_STATION,
    SET_SELECTED_BINDING,
    SET_CACHED_INSTANCES
  },
  state: {
    selectedStation: undefined,
    selectedBinding: undefined,
    cachedInstances: undefined
  }
};

export default adminUserPostModule;
